import ReactVisibilitySensor from "react-visibility-sensor";
import strategyPageData from "../data/english/strategy-page-data";
import MainHeader from "../layouts/MainHeader";
import CEOImage from '../assets/images/people/ceo.jpg';
import GallerySection from "../components/sections/GallerySection/GallerySection";
import GallerySectionRow from "../components/sections/GallerySection/GallerySectionRow";
import GallerySectionCol from "../components/sections/GallerySection/GallerySectionCol";
import GalleryCard from "../components/cards/GalleryCard";
import TitleSection from "../components/sections/TitleSection";
import SecondaryCard from "../components/cards/SecondaryCard";
import Footer from "../layouts/Footer";
import Carousel from "../components/carousel/Carousel";
import CarouselIconITextItem from "../components/carousel/CarouselIconITextItem";
import carouselData from '../data/english/carousel-content-data.json';

import carouselImage1 from "../assets/icons/carousel-icons/icon-1.svg";
import carouselImage2 from "../assets/icons/carousel-icons/icon-2.svg";
import carouselImage3 from "../assets/icons/carousel-icons/icon-3.svg";
import carouselImage4 from "../assets/icons/carousel-icons/icon-4.svg";
import carouselImage5 from "../assets/icons/carousel-icons/icon-5.svg";
import carouselImage6 from "../assets/icons/carousel-icons/icon-6.svg";
import carouselImage7 from "../assets/icons/carousel-icons/icon-7.svg";
import carouselImage8 from "../assets/icons/carousel-icons/icon-8.svg";
import carouselImage9 from "../assets/icons/carousel-icons/icon-9.svg";
import BackgroundAndCard from "../components/sections/BackgroundAndCard";
import DarkSection from "../components/sections/ColoredSection/DarkSection";
import FlexViewOne from "../components/FlexView/FlexViewOne";
import CardThree from "../components/cards/CardThree";
import ScrollView from "../components/ScrollView/ScrollView";

const carouselImages = [
    carouselImage1,
    carouselImage2,
    carouselImage3,
    carouselImage4,
    carouselImage5,
    carouselImage6,
    carouselImage7,
    carouselImage8,
    carouselImage9,
];

const StrategyPage = () => {
    return (
            <main className="page" id="main">
                <div className="sticky-view">
                    <div className="sticky-container">
                        <MainHeader 
                            image={{
                                src : require(`../assets/images/wallpaper/${strategyPageData.header.image.name}`),
                                alt : strategyPageData.header.image.alt,
                            }}
                            title={strategyPageData.header.title}
                            subtitle={strategyPageData.header.subtitle}
                            imagePosition="left"
                        />
                    </div>
                    <div className="sticky-container-two" id="mainContent">
                    <div className="chairman-section chairman-section-two">
                        <ReactVisibilitySensor
                            partialVisibility
                        >
                        {({isVisible} : any) => (
                            <img 
                                src={CEOImage} 
                                className={`bg-image an-scale-up ${isVisible ? "an-active" : ""}`} 
                                alt={strategyPageData.ceoSection.image.alt} 
                            />
                        )}
                        </ReactVisibilitySensor>
                        <div className="content">
                            <div className="wrapper-small">
                                <div className="content-box">
                                    <ReactVisibilitySensor
                                        partialVisibility
                                    >
                                    {({isVisible} : any) => (
                                        <>
                                        <p className={`description an-move-top-fade-in ${isVisible ? "an-active" : ""}`}>
                                            {strategyPageData.ceoSection.description}
                                            <br /><br />
                                            {strategyPageData.ceoSection.descriptionTwo}
                                        </p>
                                        </>
                                    )}
                                    </ReactVisibilitySensor>
                                    <ReactVisibilitySensor
                                        partialVisibility
                                    >
                                    {({isVisible} : any) => (
                                        <div className={`an-scale-x-fade-in ${isVisible ? "an-active" : ""}`}>
                                        <div className={`boardered-box ${isVisible ? "an-active" : ""}`}>
                                            <h2 className={`title ${isVisible ? "an-active" : ""}`}>{strategyPageData.ceoSection.name}</h2>
                                            <h3 className="subtitle">{strategyPageData.ceoSection.position}</h3>
                                        </div>
                                        </div>
                                    )}
                                    </ReactVisibilitySensor>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper-small">
                        <GallerySection aligment="center" >
                            <GallerySectionRow>
                            {strategyPageData.sectionOne.rowOne.map((item, index) => (
                                <GallerySectionCol key={index}>
                                    <GalleryCard 
                                        image={item.image ? {
                                            src : require(`../assets/images/cards/${item.image.name}`),
                                            alt : item.image.alt,
                                        } : undefined}
                                        title={item.title}
                                        subtitle={item.subtitle}
                                        list={item.list}
                                    />
                                </GallerySectionCol>
                            ))}
                            </GallerySectionRow>
                            <GallerySectionRow>
                            {strategyPageData.sectionOne.rowTwo.map((item, index) => (
                                <GallerySectionCol key={index}>
                                    <GalleryCard 
                                        image={item.image ? {
                                            src : require(`../assets/images/cards/${item.image.name}`),
                                            alt : item.image.alt,
                                        } : undefined}
                                        title={item.title}
                                        subtitle={item.subtitle}
                                        list={item.list}
                                    />
                                </GallerySectionCol>
                            ))}
                            </GallerySectionRow>
                        </GallerySection>
                    </div>
                    <TitleSection title={strategyPageData.titleSectionOne.title} />
                    <div className="wrapper-larg">
                    <ScrollView>
                    {
                    strategyPageData.sectionTwo.map((item, index) => (
                        <CardThree 
                            key={index}
                            icon={{
                                src : require(`../assets/icons/sections/${item.icon.name}`),
                                alt : item.icon.alt,
                            }}
                            title={item.title}
                            subtitle={item.subtitle}
                        />
                    ))
                    }
                    </ScrollView>
                    </div>
                    <TitleSection title={strategyPageData.titleSectionTwo.title} subtitle={strategyPageData.titleSectionTwo.subtitle} />
                    <div className='carousel-wrapper'>
                    <Carousel
                        settings={{
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            variableWidth: true,
                            autoplay: true,
                            speed: 3000,
                            autoplaySpeed: 0,
                            cssEase: "linear",
                            pauseOnHover: true,
                        }}
                        items={
                            carouselImages.map((icon, index) => (
                            <CarouselIconITextItem
                                    key={index}
                                    icon={icon}
                                    text={carouselData[index]} 
                                    alt={""}                            
                            />
                            ))
                        }
                    />
                    </div>
                    <BackgroundAndCard 
                        background={{
                            src : require(`../assets/images/backgrounds/${strategyPageData.backgroundAndCardSection.background.src}`),
                            alt : strategyPageData.backgroundAndCardSection.background.alt,
                        }}
                        card={{
                            title : strategyPageData.backgroundAndCardSection.card.title,
                            subtitle : strategyPageData.backgroundAndCardSection.card.subtitle,
                            image : {
                                src : require(`../assets/images/cards/${strategyPageData.backgroundAndCardSection.card.image.src}`),
                                alt : strategyPageData.backgroundAndCardSection.card.image.alt,
                            },
                            button : strategyPageData.backgroundAndCardSection.card.button,
                        }}
                    />
                    {/* <DarkSection>
                        <div className="wrapper-small">
                            <FlexViewOne>
                                {
                                strategyPageData.flexViewSection.map((item, index) => (
                                    <div className="flex-view-one-col" key={index}>
                                        <GalleryCard 
                                            key={index}
                                            title={item.title}
                                            subtitle={item.subtitle}
                                            image={{
                                                src : require(`../assets/images/cards/${item.image.name}`),
                                                alt : item.image.alt
                                            }}
                                            button={item.button}
                                        />
                                    </div>
                                ))
                                }
                            </FlexViewOne>
                        </div>
                    </DarkSection> */}
                    <Footer withBlogs={false} />
                    </div>
                </div>
            </main>
    )
}

export default StrategyPage;